import React, { Dispatch, useEffect } from 'react'

export type NotificationType = {
    type: 'success' | 'error' | 'warning';
    message: string;
}

type NotificationPopupPropsType ={
    notifications: NotificationType[];
    setNotifications: Dispatch<React.SetStateAction<NotificationType[]>>
}

const NotificationPopup = (props: NotificationPopupPropsType) => {

    // Handle close button
    const handleCloseButton = (notification: NotificationType) => {
        const index = props.notifications.indexOf(notification)
        
        if(index > -1 && index < props.notifications.length){
            /* props.setNotifications(prevState => prevState.splice(index, 1)) */
            props.setNotifications(prevState => [])
        }
    }

  return (
    <div className={`notificationContainer`}>
        {props.notifications.length > 0 && (
            props.notifications.map((notification, index) => (
                <div key={index} className={`notification ${notification.type}`}>
                    <span className={`message`}>
                        {notification.message}
                        <span className={`close`} onClick={(e) => handleCloseButton(notification)}    onTouchStart={(e) => handleCloseButton(notification)}>X</span>
                    </span>
                </div>
            ))
        )}
    </div>
  )
}

export default NotificationPopup